<script>
    import { _ } from "../services/i18n";
    import HeaderHome from "../components/HeaderHome.svelte";
    import { settingsHeaderLinksStore } from "../services/header";
    import FileUploadDialog from "../components/FileUploadDialog.svelte";
    import Form from "../components/Form.svelte";
    import InputLabel from "../components/InputLabel.svelte";
    import { uploadFile } from "../services/upload";

    let linksHeader = $settingsHeaderLinksStore;

    let filePath = null;
    let replaceLibraryData = false;
    let errorDescription = "";

    const fileSelected = (evt) => {
        if (replaceLibraryData) {
            console.log("Replace data");
        }
        else {
            console.log("Add data");
        }
        console.log(evt.detail);
    };

    const submit = async (evt) => {
        const formData = new FormData(evt.detail);
        errorDescription = await uploadFile(formData);
    }

</script>


<main>
    <HeaderHome links={linksHeader}/>
    <header>
        <h3>{$_("library_welcome")}</h3>
    </header>

    <Form cancelLabel="" buttonLabel="library.updateLibrary" on:submit={submit} rawFormData={true}>
        <div slot="extra-fields">
            <InputLabel label={$_("library_replaceLibraryData")} id="replaceLibraryData" >
                <input type="checkbox" id="replaceLibraryData" name="replaceLibraryData" bind:checked={replaceLibraryData} />
                {#if replaceLibraryData}
                    <div class="warning-message">{$_("library_replaceDataWarning")}</div>
                {/if}
            </InputLabel>
            <InputLabel label={$_("library_uploadFile")} id="dataFile" name="dataFile" required={true} >
                <FileUploadDialog id="dataFile" name="dataFile" accept="*.xls,*.xlsx" on:change={fileSelected} bind:value={filePath} required={true}/>
            </InputLabel>
            {#if errorDescription}
                <span class="error-description">{ errorDescription }</span>
            {/if}
        </div>
    </Form>

</main>

<style>
    main {
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
    }

    span.error-description {
        box-sizing: border-box;
        background: #ffc8c8;
        width: 50%;
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding: 18px;
        margin-bottom: 20px;
        margin-top: 5px;
        border-radius: 10px;
        border: 1px solid black;
    }
</style>
